import {Container} from '@mantine/core'
import {createFileRoute} from '@tanstack/react-router'

import {QuoteBuilderPage} from '../../../quotes/quote-builder-page'

export const Route = createFileRoute('/_app/quotes/new')({
    component: QuoteNewRoute,
})

function QuoteNewRoute() {
    return (
        <Container size="lg" py="xl">
            <QuoteBuilderPage mode="new" />
        </Container>
    )
}
